import { memoize } from "lodash"

import { getJsonFromScriptElement } from "Utilities/get-json-from-script-element"

// Transforms state from server into local JS data. This is a very simple module
// because front end responsibilities are small.

export interface ENVState {
  ASSET_HOST: string
  HOSTNAME: string
  JS_SEGMENT_WRITE_KEY: string
  LYSSNA_INTERCOM_APP_ID: string
  USERCROWD_INTERCOM_APP_ID: string
  APP_DOMAIN: string
  GOOGLE_SIGN_IN_ENABLED: boolean
  GOOGLE_CLIENT_ID: string
  ORTTO_TRACKING_CODE: string
  ORTTO_TRACKING_API_URL: string
  ORTTO_TRACKING_CDN_URL: string
  PANELIST_DOMAIN: string
  RELEASE: string
  S3_RECORDINGS: boolean
  SENTRY_ENABLED: boolean
  SENTRY_FRONTEND_DSN: string
  STRIPE_SCRIPT_URI: string
  STRIPE_PUBLIC_KEY: string
  VAPID_PUBLIC_KEY: number
  FIGMA_CLIENT_ID: string
  FIGMA_DOMAIN: string
  FIGMA_EMBED_DOMAIN: string
  CLIENT_VERSION: string
  GOOGLE_PLACES_API_KEY: string
  GOOGLE_PLACES_DOMAIN: string
  ANYONE_CAN_EDIT_THEIR_FEATURE_FLAGS: boolean
  ALLOW_MANUAL_PANELIST_ASSIGNMENT: boolean
  LATEST_VERSION: string
  // `IS_SYSTEM_TEST` variable is passed from Rails (app/views/layouts/base.haml) to React
  // because we always use `pnpm dev` for local testing, which runs Node and React in the
  // development environment. As a result, `process.env.NODE_ENV` always follows the value
  // set in the `.env` file. However, we need a way to distinguish between the local
  // development environment and local tests, so we added this variable for identification.
  //
  // We use it to determine whether to enable react strict mode. We only want to enable
  // strict mode in the local development environment, not in any tests. React strict mode
  // won't be enabled in production by default.
  IS_SYSTEM_TEST?: boolean
}

export const getEnvState = memoize(() => {
  const envState = getJsonFromScriptElement<ENVState | null>("env", null)
  if (envState === null) {
    throw Error("No env set")
  }
  return envState
})

interface ApplicationState {
  isEmulatingUser: boolean
  recaptchaSiteKey: string | null
  resetPasswordToken: string | null
}

export const getApplicationState = memoize(() => {
  const applicationState = getJsonFromScriptElement<ApplicationState | null>(
    "application_state",
    null
  )

  if (applicationState === null) {
    throw Error("No application state set")
  }
  return applicationState
})
